import { createFastContext } from '@rst/libs-ts'
import { RenderBlockTheme } from '../types'

export const {
	useCtx: useRenderBlockTheme,
	Provider: RenderBlockThemeProvider,
} = createFastContext<RenderBlockTheme>({
	borderRadius: 8,
	inputBorderRadius: 8,
	buttonBorderRadius: 8,
	colorPaletteName: 'none',
	colors: {},
	darkTheme: false,
	font: {
		main: 'Inter',
		family_main: 'sans-serif',
		head: 'Inter',
		family_head: 'sans-serif',
	},
})
